<template>
    <tr v-if="row.left.capacity_warning.show || row.right.capacity_warning.show">
        <td></td>
        <side-by-side-row-lvl2-warning-cell :data="row.left" :colspan="colspan"/>
        <td class="table-center-separator">
        </td>
        <side-by-side-row-lvl2-warning-cell :data="row.right" :colspan="colspan"/>
        <td></td>
    </tr>
    <tr v-else style="display: none"></tr>
</template>

<script>
import SideBySideRowLvl2WarningCell from "./side-by-side-row-lvl2-warning-cell";

export default {
    components: {SideBySideRowLvl2WarningCell},
    props: [
        'row', 'colspan'
    ]
}
</script>
